import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Analisis/addAnalisis`, method: 'POST', body: values, token: token})
}
